import pickBy from 'lodash/pickBy';
import startsWith from 'lodash/startsWith';

export const getUtmDataForSalesFloorApp = (query) => {
  const utmData = pickBy(query, (_, key) => startsWith(key, 'utm_'));
  const utmMedium = utmData?.utm_medium;

  if (Object.keys(utmData).length === 0 || utmMedium !== 'pos') {
    return null;
  }

  const productTemplateSlug = query?.productTemplateSlug;
  const utmCampaign = utmData?.utm_campaign?.split('-');
  const retailLocation: string = utmCampaign?.[0];
  const associateId: string = utmCampaign?.[1];

  return {
    product_template_slug: productTemplateSlug,
    associate_id: associateId,
    retail_location: retailLocation,
    utm_source: `fc_salesfloor_app_${retailLocation}`,
  };
};
